import { Suspense } from 'react';
import { Flex, Layout } from 'antd';
import useWindowSize from '../../hooks/useWindowSize';
import AnalyticsLayoutMenu from './AnalyticsLayoutMenu';

const { Content } = Layout;

const AnalyticsLayout = ({ children, fullPage }) => {
  const { isMobile } = useWindowSize();

  return (
    <Layout>
      <Flex
        vertical={isMobile}
        className={`${fullPage ? 'full_width' : 'width_60_percent'}`}
      >
        <AnalyticsLayoutMenu />
        <Content
          className={`main_content padding_10 ${
            fullPage ? 'full_width' : 'width_600px'
          }`}
        >
          <Suspense fallback={null}>{children}</Suspense>
        </Content>
      </Flex>
    </Layout>
  );
};

export default AnalyticsLayout;
